import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { NonWorkingDay } from "@app/models/rest/roster/non-working-day";

@Injectable({
  providedIn: "root"
})
export class NonWorkingDayRestService extends HateoasResourceOperation<NonWorkingDay> {
  constructor() {
    super(NonWorkingDay);
  }
}
